import { render, staticRenderFns } from "./CatalogFooter.vue?vue&type=template&id=572ee9de"
import script from "./CatalogFooter.vue?vue&type=script&lang=ts"
export * from "./CatalogFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogCollections: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogCollections.vue').default,ElementSeoText: require('/codebuild/output/src1993466134/src/acredo-website/components/element/elementSeoText.vue').default})
